"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { Button } from "@/src/components/shadcn/ui/button";
import { useResumeWorkflowStepMutation, useWorkflowStepResumeCheck } from "@/src/lib/data-fetchers/tasks-fetchers";
import type { Task } from "@/src/models/task";
import { TaskStepStatus, type TaskStep } from "@/src/models/task-step";
export function WorkflowStepResumeButton(t0) {
  const $ = _c(15);
  const {
    task,
    step
  } = t0;
  const check = useWorkflowStepResumeCheck(task);
  const resume = useResumeWorkflowStepMutation(task);
  const router = useRouter();
  const isRetry = step.status === TaskStepStatus.FAILED;
  const canResume = check.data?.resumable && check.data.taskStepId === step.id;
  let t1;
  if ($[0] !== check.data || $[1] !== check.error || $[2] !== resume.error) {
    t1 = resume.error || check.error ? <p className="text-sm text-destructive" role="alert">{resume.error?.message ?? check.error?.message}</p> : check.data && !check.data.resumable ? <p className="text-sm text-muted-foreground">{check.data.reason}</p> : null;
    $[0] = check.data;
    $[1] = check.error;
    $[2] = resume.error;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== canResume || $[5] !== check.error || $[6] !== check.isPending || $[7] !== isRetry || $[8] !== resume || $[9] !== router || $[10] !== step.id) {
    t2 = check.isPending || check.error || canResume ? <Button disabled={!canResume || resume.isPending || resume.isSuccess} onClick={() => resume.mutate(step.id, {
      onSettled: () => router.refresh()
    })}>{resume.isPending || resume.isSuccess ? isRetry ? "Retrying\u2026" : "Resuming\u2026" : isRetry ? "Retry" : "Resume"}</Button> : null;
    $[4] = canResume;
    $[5] = check.error;
    $[6] = check.isPending;
    $[7] = isRetry;
    $[8] = resume;
    $[9] = router;
    $[10] = step.id;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2) {
    t3 = <div className="space-y-3">{t1}{t2}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}